/* global Office,document */
import * as utils from "./utils";

export async function fillItemBox(created, subject, from, to, cc, body, attachments) {
  //ITEM
  const item = Office.context.mailbox.item;

  //SUBJECT
  subject.val(item.subject);

  //FROM
  from.val(item.from.displayName + " <" + item.from.emailAddress + ">");

  //CREATED
  created.val(item.dateTimeCreated.toLocaleDateString());

  //BODY
  item.body.getAsync("html", function (result) {
    let bodyTxt = "";
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      bodyTxt = utils.limit(result.value, 500);
    }
    body.val(bodyTxt);
  });

  //TO
  var toString = "";
  if (item.to.length > 0) {
    toString = "";
    item.to.forEach(function (value) {
      toString += "" + value.displayName + " <" + value.emailAddress + ">; ";
    });
  }
  to.val(toString);

  //CC
  var ccString = "";
  if (item.cc.length > 0) {
    ccString = "";
    item.cc.forEach(function (value) {
      ccString += "" + value.displayName + " <" + value.emailAddress + ">; ";
    });
  }
  cc.val(ccString);

  //ATTACHMENT
  var attachmentsString = "";
  if (item.attachments.length > 0) {
    attachmentsString = "";
    item.attachments.forEach(function (value) {
      if(value.name.endsWith(".pdf"))
        attachmentsString += "" + value.name + "; ";
    });
    attachments.val(attachmentsString);
  }
}

export function validateUsernamePassword(username, password, alertUsername, alertPassword) {
  let valid = true;
  if (username.length < 1) {
    document.getElementById(alertUsername).style.display = "flex";
    valid = false;
  }
  if (password.length < 1) {
    document.getElementById(alertPassword).style.display = "flex";
    valid = false;
  }
  return valid;
}
